<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageNavSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        transition(name="fade", mode="out-in")
            router-view(:lang="lenguage")
</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'
import careersBanner from '@img/careers/Banner_CAREERS.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
        console.log(this.lang)
    },
    components: {
        PmBreadcrumbs, PmBanner, PmSidebar
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

        window.scroll({
            top: to,
            left: 0,
            behavior: 'smooth'
        })

    this.moveToDown = !this.moveToDown
    },
    data: function(){
        return{
            lenguage: 'EN',
            enContent: {
                title: 'CAREERS',
                breadcrumb: {name:'CAREERS', link:'/en/careers'},
            },
            esContent: {
                title: 'OPORTUNIDADES',
                breadcrumb: {name:'Oportunidades', link:'/es/oportunidades'},
            },
            banner: careersBanner,
            
            section: ''
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>
    select{
        background-color: white;
        color: #626262;
        border: 1px solid #ccc;
        height: 35px;
        border-radius: 0px;
        font-size: 12px;
    }
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmCareers.vue